import { Component, OnInit, Input } from '@angular/core';
import isEmpty from 'lodash-es/isEmpty';
import { LoggerService } from '@wdpr/ra-angular-logger';

const RESIZE = {
    big: {
        value: 40,
        cssClass: 'resize-big'
    },
    small: {
        value: 35,
        cssClass: 'resize-small'
    }
};
const loggerBaseMessage = `FINDER-TITLE --`;

@Component({
    selector: 'finder-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss']
})
export class TitleComponent implements OnInit {
    @Input() public title: string;
    /* eslint-disable @angular-eslint/no-input-rename */
    @Input('over-title') public overTitle: string;
    @Input() icon: any;

    sizeClass: string;
    showOverTitle: boolean;

    constructor(
        private logger: LoggerService
    ) { }

    ngOnInit() {
        if (isEmpty(this.title)) {
            this.logger.error(`${loggerBaseMessage} title is empty`);

            return;
        }

        const length: number = this.title.length;
        this.sizeClass = '';
        const classes = [];

        if (length > RESIZE.big.value) {
            classes.push(RESIZE.big.cssClass);
        }

        if (length > RESIZE.small.value) {
            classes.push(RESIZE.small.cssClass);
        }

        this.sizeClass = classes.join(' ');
        this.showOverTitle = !isEmpty(this.overTitle);
    }

}
